import { Col, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import cisMenyApi from 'services/cisMeny';
import cisStatyApi from 'services/cisStaty';
import {
    EPristupStav,
    IZadostPravoLoginResp,
    zadostPravoLoginGet,
    zadostPravoLoginSMS,
    zadostPravoLoginSMSlogin
} from 'services/spravaEmitenta/zadostPravo';

import routePathEnum from 'enums/routePathEnum';

import smsKodValidation from 'utils/validations/smsKodValidation';

interface IZadostOkomunikaciLogin {}

const ZadostOkomunikaciLogin: React.FC<IZadostOkomunikaciLogin> = () => {
    const { token } = useContext(Context);
    const { setLevel } = useProfily();
    const { navigateWorkaround } = useNavigateWorkaround();
    const [loading, setLoading] = useState<boolean>(false);
    const [errMessage, setErrMessage] = useState<string>('');
    const [showInput, setShowInput] = useState<boolean>(false);
    const [smsCodeErr, setSmsCodeErr] = useState<boolean>(false);
    const [smsResp, setSmsResp] = useState<IZadostPravoLoginResp>();
    const { hash } = useParams<{ hash: string }>();

    useEffect(() => {
        zadostPravoLoginGet(hash!).then(resp => setSmsResp(resp));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        token && navigateWorkaround(routePathEnum.AMLZ_ZADOST_O_AGENDU);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const poslatSms = () => {
        setLoading(true);
        zadostPravoLoginSMS(hash!)
            .catch(() => setErrMessage('RESPONSE_ERROR_400'))
            .then(() => setShowInput(true))
            .finally(() => setLoading(false));
    };

    return (
        <AuthWrapper>
            {smsResp?.platnost ? (
                <>
                    {!showInput ? (
                        <LoadingWrapper loading={loading}>
                            <Title text="IDENTIFIKACE_OSOBY" level={5} />
                            <Paragraph
                                style={{
                                    display: 'block'
                                }}
                                text="IDENTIFIKACE_OSOBY_TEXT"
                            />
                            <Col>
                                <Row className="button-row">
                                    <ButtonComponent
                                        buttontext="ZASLAT_SMS_KOD"
                                        onClick={poslatSms}
                                        id="pxKlicPokracovatBtn"
                                    />
                                </Row>
                            </Col>
                        </LoadingWrapper>
                    ) : (
                        <>
                            {showInput && (
                                <>
                                    <Title text="IDENTIFIKACE_OSOBY" level={5} />
                                    <Paragraph text="IDENTIFIKACE_OSOBY_KOD" />
                                    <div
                                        style={{
                                            margin: 10
                                        }}
                                    >
                                        <FormWrapper
                                            onFinish={vals => {
                                                setSmsCodeErr(false);
                                                setLoading(true);
                                                zadostPravoLoginSMSlogin(hash!, vals.kod)
                                                    .then(resp => {
                                                        if (!resp.token) {
                                                            setSmsCodeErr(true);
                                                        } else {
                                                            setLevel('zadostAgenda', {
                                                                pristupc2: {
                                                                    id: resp.idzaznamu,
                                                                    idosoby: resp.idosoby,
                                                                    stav: EPristupStav.ROZP,
                                                                    stat: resp.stat
                                                                }
                                                            });
                                                            setLevel('token', resp.token);
                                                            cisStatyApi().then(({ data }) => {
                                                                setLevel('cisStaty', data);
                                                            });
                                                            cisMenyApi().then(({ data }) => {
                                                                setLevel('cisMeny', data);
                                                            });
                                                        }
                                                    })
                                                    .catch(() => setSmsCodeErr(true))
                                                    .finally(() => setLoading(false));
                                            }}
                                        >
                                            <InputComponent label="CODE" name="kod" rules={smsKodValidation()} />
                                            <Row>
                                                <ButtonComponent
                                                    buttontext="POKRACOVAT"
                                                    id="pxKlicPokracovatBtn"
                                                    htmlType="submit"
                                                    loading={loading}
                                                    extramessage={smsCodeErr ? 'SMS_INVALID' : ''}
                                                />

                                                {errMessage && <TranslateText>{errMessage}</TranslateText>}
                                            </Row>
                                        </FormWrapper>
                                    </div>
                                    <Row>
                                        <TranslateText>SMS_RESEND_TXT</TranslateText>
                                        <ButtonComponent
                                            id="sendSMSbtn"
                                            style={{
                                                marginTop: -8,
                                                marginLeft: 10
                                            }}
                                            htmlType="button"
                                            type="primary"
                                            buttontext="SMS_RESEND_BTN"
                                            loading={loading}
                                            onClick={poslatSms}
                                        />
                                    </Row>
                                </>
                            )}
                        </>
                    )}
                </>
            ) : (
                <Title level={5} text="PRAVO_ZADOST_EXPIRED" />
            )}
        </AuthWrapper>
    );
};

export default ZadostOkomunikaciLogin;
